// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordModal":"ResetPasswordForm_resetPasswordModal__3px9V","btnGeneratePassword":"ResetPasswordForm_btnGeneratePassword__g4bb5","label":"ResetPasswordForm_label__1C-_1"};